export const environment = {
  production: true,
  jwtName: 'jwt',
  domainLogin: 'https://clientmobile.rpa360.com',
  domainCookie: 'clientmobile.rpa360.com',
  tracing: true,
  clientId: 'mobileui',
  issuer: 'https://api.rpa360.com:4101',
  skipIssuerCheck: false,
  sendToSentry: true,
  tracesSampleRate: 0.3,
  replaysSessionSampleRate: 0,
  replaysOnErrorSampleRate: 0.20
};
